<template>
  <header>
    <TopBar :scroll-top="top" />
  </header>

  <main
    ref="scrollRef"
    class="relative scroll-v h-screen"
    @scroll="onScroll"
  >
    <div class="min-h-screen">
      <router-view />
    </div>

    <footer>
      <FootBar />
    </footer>
  </main>
</template>

<script setup lang="ts">
  import TopBar from "@/layout/TopBar.vue"
  import FootBar from "@/layout/FootBar.vue"

  const route = useRoute()
  const scrollRef = ref()

  let top = ref(0)

  watch(() => route.path, () => {
    scrollRef.value.scrollTo({ top: 0, behavior: 'smooth' })
  })

  function onScroll(e: any) {
    top.value = e.target.scrollTop
  }

</script>

<style lang="scss">
  header {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    padding: 40px;
  }

  footer {
    background-color: #031628;
  }
</style>
